import { useState, useEffect } from "react";
import api from "../../../../../services/api";

export const FetchStatus = {
  SUCCESS: "success",
  ERROR: "error",
  LOADING: "loading"
};

const responseMocked = [
  {
    id: 20,
    valor_parcela: 9240.52,
    valor_parcela_antigo: 9690.98,
    dt_cadastro: "2024-01-08",
    parcela: 145
  },
  {
    id: 243,
    valor_parcela: 10400.79,
    valor_parcela_antigo: 10631.26,
    dt_cadastro: "2024-01-08",
    parcela: 145
  }
];

export const useFetchHistory = id_parcela => {
  const [status, setStatus] = useState(FetchStatus.LOADING);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!id_parcela) return;

    api
      .get(`/contratos/valores/${id_parcela}`)
      .then(({ data }) => {
        setData(data);
        setStatus(FetchStatus.SUCCESS);
      })
      .catch(err => {
        console.error(err);
        setStatus(FetchStatus.ERROR);
      });
  }, [id_parcela]);

  return {
    status,
    data
  };
};



// WEBPACK FOOTER //
// ./src/pages/Pasta/Contratos/Contrato/ValueHistory/use-fetch-history.js